/* Progressive reveal for collection grids: 25 cards on load, +25 per "Show More" click.
   Composes with ef-collection-filter.js — the filter hides non-matching cards via the
   [hidden] property; this layer only caps the cards the filter left visible using the
   .ef-card-capped class, and resets to 25 whenever the filter or sort changes
   (ef:collf:applied). All cards remain in the HTML for crawlers; the cap is JS-only,
   so no-JS user agents see the full grid. */
(function () {
  'use strict';
  var STEP = 25;

  function init() {
    var grid = document.querySelector('.ef-coll-grid');
    var wrap = document.querySelector('[data-ef-more]');
    if (!grid || !wrap) return;
    var btn = wrap.querySelector('[data-ef-more-btn]');
    var limit = STEP;

    function applyCap() {
      var cards = Array.prototype.slice.call(grid.querySelectorAll('.ef-coll-card'));
      var shown = 0;
      var capped = 0;
      cards.forEach(function (c) {
        if (c.hidden) { c.classList.remove('ef-card-capped'); return; }
        var over = shown >= limit;
        c.classList.toggle('ef-card-capped', over);
        if (over) capped++; else shown++;
      });
      wrap.hidden = capped === 0;
      if (btn && capped > 0) {
        btn.textContent = 'Show More (' + capped + ' remaining)';
      }
    }

    if (btn) {
      btn.addEventListener('click', function () {
        limit += STEP;
        applyCap();
      });
    }
    document.addEventListener('ef:collf:applied', function () {
      limit = STEP;
      applyCap();
    });
    applyCap();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
